
const testimonials = [
  {
    name: 'Rodrigo Fonseca',
    role: 'Proprietário · Asa Sul, Brasília',
    text: 'Tentei vender meu apartamento por conta própria por 6 meses sem sucesso. Com o Daniel, em menos de 30 dias recebi uma proposta excelente e fechei o negócio. Atendimento impecável!',
    rating: 5,
    image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20man%20portrait%20smiling%20confident%20real%20estate%20owner%20Brasilia%20DF%20modern%20background%20natural%20lighting&width=200&height=200&seq=prop-test-001&orientation=squarish',
    tag: 'Venda',
  },
  {
    name: 'Patrícia Drummond',
    role: 'Proprietária · Lago Norte, Brasília',
    text: 'Precisava alugar minha casa rapidamente e o Daniel encontrou um inquilino qualificado em apenas 2 semanas. Todo o processo foi transparente e seguro. Super recomendo!',
    rating: 5,
    image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20woman%20portrait%20smiling%20confident%20property%20owner%20Brasilia%20DF%20elegant%20background%20natural%20lighting&width=200&height=200&seq=prop-test-002&orientation=squarish',
    tag: 'Aluguel',
  },
  {
    name: 'Marcelo Tavares',
    role: 'Proprietário · Águas Claras, Brasília',
    text: 'A avaliação gratuita foi surpreendente — o Daniel identificou que meu imóvel valia mais do que eu imaginava. Vendi acima do preço que esperava. Profissional excepcional!',
    rating: 5,
    image: 'https://readdy.ai/api/search-image?query=successful%20brazilian%20businessman%20portrait%20confident%20investor%20Brasilia%20DF%20modern%20office%20background%20professional%20lighting&width=200&height=200&seq=prop-test-003&orientation=squarish',
    tag: 'Venda',
  },
  {
    name: 'Camila Rezende',
    role: 'Proprietária · Sudoeste, Brasília',
    text: 'Fiquei impressionada com a qualidade das fotos e a divulgação do meu apartamento. Recebi várias visitas qualificadas logo na primeira semana. Resultado incrível!',
    rating: 5,
    image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20woman%20smiling%20portrait%20elegant%20real%20estate%20owner%20Brasilia%20DF%20bright%20background%20natural%20lighting&width=200&height=200&seq=prop-test-004&orientation=squarish',
    tag: 'Aluguel',
  },
  {
    name: 'Eduardo Meireles',
    role: 'Proprietário · Noroeste, Brasília',
    text: 'O Daniel cuidou de tudo: documentação, visitas, negociação. Eu não precisei me preocupar com nada. Vendi meu imóvel com segurança e pelo melhor preço do mercado.',
    rating: 5,
    image: 'https://readdy.ai/api/search-image?query=confident%20brazilian%20professional%20man%20portrait%20smiling%20property%20seller%20Brasilia%20DF%20corporate%20background%20natural%20lighting&width=200&height=200&seq=prop-test-005&orientation=squarish',
    tag: 'Venda',
  },
  {
    name: 'Juliana Borges',
    role: 'Proprietária · Park Way, Brasília',
    text: 'Minha casa estava parada há meses com outra imobiliária. Mudei para o Daniel e em 3 semanas já tinha inquilino. A diferença no atendimento e na estratégia é enorme!',
    rating: 5,
    image: 'https://readdy.ai/api/search-image?query=professional%20brazilian%20woman%20portrait%20confident%20smiling%20real%20estate%20client%20Brasilia%20DF%20elegant%20modern%20background&width=200&height=200&seq=prop-test-006&orientation=squarish',
    tag: 'Aluguel',
  },
];

const TestimonialsProprietarios = () => (
  <section className="py-24 bg-gray-50">
    <div className="container mx-auto px-4">
      <div className="text-center mb-16">
        <span className="inline-block px-4 py-2 bg-teal-100 rounded-full text-teal-700 font-semibold text-sm tracking-wider uppercase mb-4">
          Depoimentos
        </span>
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
          Proprietários Que Confiaram{' '}
          <span className="bg-gradient-to-r from-teal-600 to-emerald-600 bg-clip-text text-transparent">
            e Tiveram Resultado
          </span>
        </h2>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
          Histórias reais de proprietários em Brasília que venderam ou alugaram seus imóveis com sucesso
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {testimonials.map((t, i) => (
          <div
            key={i}
            className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all hover:-translate-y-1 border border-gray-100"
          >
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 rounded-full overflow-hidden border-2 border-teal-400 flex-shrink-0">
                  <img src={t.image} alt={t.name} className="w-full h-full object-cover object-top" />
                </div>
                <div>
                  <div className="font-bold text-gray-900 text-sm">{t.name}</div>
                  <div className="text-xs text-gray-500">{t.role}</div>
                </div>
              </div>
              <span className={`text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap ${t.tag === 'Venda' ? 'bg-teal-100 text-teal-700' : 'bg-orange-100 text-orange-700'}`}>
                {t.tag}
              </span>
            </div>

            <div className="flex gap-1 mb-4">
              {[...Array(t.rating)].map((_, j) => (
                <i key={j} className="ri-star-fill text-yellow-400 text-base"></i>
              ))}
            </div>

            <p className="text-gray-700 leading-relaxed text-sm italic">"{t.text}"</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default TestimonialsProprietarios;
